import {getErrorCodeFromResponse, getErrorMessageFromResponse} from "@/mixins/errorMessage";

export const getErrorMessageFromQuoteCreationProcess = (response: any): string|null => {
  const errorCode: string|null = getErrorCodeFromResponse(response);

  if (null === errorCode) {
    return null;
  }

  // get product name from error message response
  let productName: string|null = getErrorMessageFromResponse(response);

  if (null === productName) {
    productName = '';
  }

  // get sim number from error message response
  const message = getErrorMessageFromResponse(response);
  let simNumber: string = '';

  if (message) {
    const regex = /\b\d{19}\b/g;

    const simNumbers = message.match(regex);

    simNumber = simNumbers && simNumbers.length > 0 ? simNumbers[0] : '';
  }

  let errorMessage: string|null = null;

  switch (errorCode) {
    case 'ERR_REQUESTED_ADDON_PRODUCT_COUNT_EXCEEDS_ALLOWED_LIMIT':
      errorMessage = 'U kunt geen extra add-ons voor product "' + productName + '" toevoegen, omdat u de eerder in het offerteproces gekozen limiet hebt bereikt.';
      break;

    case 'ERR_SIM_NUMBER_NOT_FOUND':
      errorMessage = 'Simkaartnummer ' + simNumber + ' kon niet worden gevonden in het systeem.';
      break;

    case 'ERR_SIM_CARD_NOT_AVAILABLE':
      errorMessage = 'Simkaartnummer ' + simNumber + ' is niet beschikbaar.';
      break;

    case 'ERR_DATE_MUST_BE_IN_FUTURE':
      errorMessage = 'Wensdatum voor product "' + productName + '" moet in de toekomst liggen.';
      break;

    case 'ERR_DATE_MUST_BE_WORKING_DAY':
      errorMessage = 'Wensdatum voor product "' + productName + '" moet op werkdag worden ingesteld.';
      break;

    case 'ERR_INTERNET_DATE_NOT_ALLOWED':
      errorMessage = 'Minimale wensdatum voor product "' + productName + '" moet 10 werkdagen in de toekomst liggen.';
      break;

    case 'ERR_MOBILE_DATE_NOT_ALLOWED':
      errorMessage = 'De wensdatum voor het product "' + productName + '" moet tussen vandaag en 120 dagen in de toekomst liggen.';
      break;

    case 'ERR_MOBILE_PORTING_DATE_NOT_ALLOWED':
      errorMessage = 'De wensdatum voor het product "' + productName + '" moet tussen 20 werkdagen en 120 dagen in de toekomst liggen.';
      break;

    case 'ERR_MOBILE_PORTING_DATE_NOT_ALLOWED_TERMINATE_ON_END_DATE':
      errorMessage = 'De wensdatum voor het product "' + productName + '" moet tussen 23 werkdagen en 120 dagen in de toekomst liggen.';
      break;

    case 'ERR_MOBILE_PORTING_DATE_NOT_ALLOWED_OTHER':
      errorMessage = 'De wensdatum voor het product "' + productName + '" moet tussen 5 werkdagen en 120 dagen in de toekomst liggen.';
      break;

    case 'ERR_EMPTY_PHONE_NUMBER':
      errorMessage = 'U heeft een leeg telefoonnummer ingevoerd voor het product "' + productName + '".';
      break;

    case 'ERR_INVALID_PHONE_NUMBER':
      errorMessage = 'U heeft een ongeldig telefoonnummer ingevoerd voor het product "' + productName + '".';
      break;

    case 'ERR_EMPTY_EMAIL':
      errorMessage = 'U heeft een leeg e-mailadres ingevoerd voor het product "' + productName + '".';
      break;

    case 'ERR_INVALID_EMAIL':
      errorMessage = 'U heeft een ongeldig e-mailadres ingevoerd voor het product "' + productName + '".';
      break;

    case 'ERR_EMPTY_SIM_NUMBER':
      errorMessage = 'U heeft geen simkaartnummer ingevoerd voor het product "' + productName + '".';
      break;

    case 'ERR_INVALID_NUMBER_TO_PORT':
      errorMessage = 'U heeft een ongeldig nummer ingevoerd om het product te porteren "' + productName + '". Het nummer moet beginnen met een nul.';
      break;

    case 'ERR_EMPTY_PORTING_CUSTOMER_NUMBER':
      errorMessage = 'U heeft geen klantnummer ingevoerd voor het product "' + productName + '".';
      break;

    case 'ERR_MULTIPLE_BELLEN_ADDONS_SELECTED':
      errorMessage = 'U kunt slechts een Bellen add-on selecteren voor het product "' + productName + '".';
      break;

    case 'ERR_MIGRATIE_AND_NLS_BOTH_SELECTED':
      errorMessage = 'Er kan slechts één van Migratie of NLS worden geselecteerd.';
      break;

    case 'ERR_MIGRATIE_OR_NLS_NOT_SELECTED':
      errorMessage = 'Migratie of NLS moet worden geselecteerd.';
      break;

    case 'ERR_SPRAAKKANAAL_NOT_SELECTED':
      errorMessage = 'Onbeperkt Bellen kan niet worden geselecteerd zonder SIP Trunk spraakkanaal.';
      break;

    case 'ERR_HORIZON_LICENTIE_NOT_SELECTED':
      errorMessage = 'Onbeperkt Bellen kan niet worden geselecteerd zonder Horizon licentie.';
      break;

    case 'ERR_DONGLE_INTERNET_BACKUP_PLUS_NOT_SELECTED':
      errorMessage = 'Dongle kan alleen worden geselecteerd met Internet Backup Plus.';
      break;

    case 'ERR_ROUTER_INSTALL_INTERNET_BACKUP_PLUS_NOT_SELECTED':
      errorMessage = 'Routerinstallatie kan alleen worden geselecteerd met Internet Backup Plus.';
      break;

    case 'ERR_BACKUP_OPTIONS_REQUIRED':
      errorMessage = 'Voor Internet Backup Plus is het vereist Dongle of Router en Installatie te selecteren.';
      break;

    case 'ERR_MULTIPLE_MULTISIM_SELECTED':
      errorMessage = 'U kunt maximaal 4 MultiSIMs selecteren voor het product "' + productName + '".';
      break;

    case 'ERR_MULTISIM_DUO_MB_SHARING_NOT_ALLOWED':
      errorMessage = 'MultiSIM kan niet worden geselecteerd in combinatie met MB Verdeler of een Duo product.';
      break;

    case 'ERR_DIFF_CLOUD_ONBEPERKT_BELLEN_ALREADY_EXISTS':
      errorMessage = 'Product "' + productName + '" kan niet worden toegevoegd omdat er al een ander Onbeperkt product actief is voor deze klant.';
      break;
  }

  return errorMessage;
};
